import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { push, ref } from "firebase/database";
import { add, addSupplierToList } from "../../redux/slices/supplier";
import { database } from "../../firebaseConfig";
import { setLoading } from "../../redux/slices/ui";
import Modal from "../ui/Modal";
import Button from "../ui/Button";
import { Input } from "../ui/Field";

const ModalAddSupplier = () => {
  const dispatch = useDispatch();
  const show = useSelector((state) => state.suppliers.add);

  const [name, setName] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [commission, setCommission] = React.useState("");

  React.useEffect(() => {
    if (!show) {
      setName("");
      setPhone("");
      setEmail("");
      setCommission("");
    }
  }, [show]);

  const handleClose = () => dispatch(add(false));

  const handleSave = async () => {
    dispatch(setLoading(true));
    const data = { name, email, phone, commission: parseFloat(commission).toFixed(2) };
    const response = await push(ref(database, "suppliers"), data);
    dispatch(addSupplierToList({ key: response.key, value: data }));
    dispatch(setLoading(false));
    handleClose();
  };

  const handlePromitheiaChange = (e) => {
    const value = e.target.value.replace(",", ".");
    if (!isNaN(value) && value >= 0 && value <= 100) setCommission(value);
  };

  return (
    <Modal
      open={!!show}
      onClose={handleClose}
      title="Νέος προμηθευτής"
      footer={
        <>
          <Button variant="secondary" onClick={handleClose}>
            Ακύρωση
          </Button>
          <Button onClick={handleSave}>Αποθήκευση</Button>
        </>
      }
    >
      <div className="space-y-3 py-1">
        <Input label="Επωνυμία" value={name} autoComplete="off" onChange={(e) => setName(e.target.value)} />
        <Input label="Τηλέφωνο" type="tel" value={phone} autoComplete="off" onChange={(e) => setPhone(e.target.value)} />
        <Input label="email" type="email" value={email} autoComplete="off" onChange={(e) => setEmail(e.target.value)} />
        <Input label="Προμήθεια %" inputMode="decimal" value={commission} autoComplete="off" onChange={handlePromitheiaChange} />
      </div>
    </Modal>
  );
};

export default ModalAddSupplier;
